// src/app/navigation.service.ts

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor() { }

  /**
   * Navigates to an external URL.
   * @param url The external URL to navigate to.
   */
  public goToExternalUrl(url: string): void {
    // It's safe to use window.location.href here because
    // this service can be mocked for testing.
    window.location.href = url;
  }

  /**
   * Opens a URL in a popup window with specified dimensions and features
   * @param url The URL to open in the popup
   * @param name The name of the popup window
   * @param width The width of the popup window
   * @param height The height of the popup window
   * @param features Additional window features
   * @returns The popup window reference or null if blocked
   */
  public openPopup(
    url: string,
    name: string = 'popup',
    width: number = 600,
    height: number = 700,
    features?: string
  ): Window | null {
    // Calculate center position
    const left = Math.max(0, (screen.width - width) / 2);
    const top = Math.max(0, (screen.height - height) / 2);

    // Default features for OAuth popup
    const defaultFeatures = [
      `width=${width}`,
      `height=${height}`,
      `left=${left}`,
      `top=${top}`,
      'scrollbars=yes',
      'resizable=yes',
      'status=no',
      'toolbar=no',
      'menubar=no',
      'location=no'
    ].join(',');

    const windowFeatures = features || defaultFeatures;

    try {
      return window.open(url, name, windowFeatures);
    } catch (error) {
      console.error('Failed to open popup window:', error);
      return null;
    }
  }
}
